<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Alterar dados da empresa'" :showBtn="true" :btnName="'Voltar'" :btnRoute="
          '/detalhes-da-empresa/' +
          this.$route.params.idCompany +
          '/' +
          this.$route.params.context
        " :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <div v-if="!loadingList && dataPaymentCompany" class="col-xs-12 col-sm-12 col-md-12 offset-top-20">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <form>
                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Nome da empresa</label>
                        <input v-model="dataPaymentCompany.company.name" type="text" name="nomedaempresa"
                               id="nomedaempresa" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Nome de contato</label>
                        <input v-model="dataPaymentCompany.company.contactName" type="text" name="nomedecontato"
                               id="nomedecontato" class="form-control" disabled/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>E-mail</label>
                        <input v-model="dataPaymentCompany.company.email" type="text" name="email" id="email"
                               class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>E-mail financeiro</label>
                        <input v-model="dataPaymentCompany.company.financialEmail" type="text" name="emailfinanceiro"
                               id="emailfinanceiro" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label for="cnpj">CNPJ</label>
                        <input v-model="
                            dataPaymentCompany.company.bussinessInfo.cnpj
                          " v-mask="['##.###.###/####-##']" type="text" name="cnpj" id="cnpj" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Razão social</label>
                        <input v-model="
                            dataPaymentCompany.company.bussinessInfo
                              .representationName
                          " type="text" name="razaosocial" id="razaosocial" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Telefone</label>
                        <input v-model="dataPaymentCompany.company.phone.phoneNumber"
                               v-mask="['(##) ####-####', '(##) #####-####', '(##) ######-####', '(##) ## #########', '(###) ## #########']"
                               type="text" name="telefone" id="telefone"
                               class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>CEP</label>
                        <input v-model="dataPaymentCompany.company.address.zipCode" type="text" name="cep"
                               v-mask="['#####-###']" id="cep" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Endereço</label>
                        <input v-model="dataPaymentCompany.company.address.street" type="text" name="endereço"
                               id="endereço" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Número</label>
                        <input v-model="dataPaymentCompany.company.address.number" type="text" name="number" id="number"
                               class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Bairro</label>
                        <input v-model="
                            dataPaymentCompany.company.address.neighborhood
                          " type="text" name="neighborhood" id="neighborhood" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Cidade</label>
                        <input v-model="dataPaymentCompany.company.address.city" type="text" name="city" id="city"
                               class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Estado</label>
                        <input v-model="dataPaymentCompany.company.address.state" type="text" maxlength="2" name="state"
                               id="state" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Complemento</label>
                        <input v-model="
                            dataPaymentCompany.company.address.complement
                          " type="text" name="complement" id="complement" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Latitude</label>
                        <input v-model="dataPaymentCompany.company.address.latitude" type="text" name="latitude"
                               id="latitude" class="form-control"/>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Longitude</label>
                        <input v-model="dataPaymentCompany.company.address.longitude" type="text" name="longitude"
                               id="longitude" class="form-control"/>
                      </div>
                    </div>

                    <div class="form-group">
                      <label>
                        Dados para nota fiscal.
                      </label>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label>CNPJ para nota fiscal</label>
                          <input v-model="datafinancialInfo.financialInfo.cnpj" v-mask="['##.###.###/####-##']"
                                 type="text" name="cnpj" id="cnpj" class="form-control"/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label>razão social para nota fiscal</label>
                          <input v-model="datafinancialInfo.financialInfo.representationName" type="text"
                                 name="representationName" id="representationName" class="form-control"/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label>CEP para nota fiscal</label>
                          <input v-model="datafinancialInfo.financialInfo.zipCode" v-mask="['#####-###']" type="text"
                                 name="zipCode" id="zipCode" class="form-control"/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label>Endereço para nota fiscal</label>
                          <input v-model="datafinancialInfo.financialInfo.street" type="text" name="street" id="street"
                                 class="form-control"/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label>Número para nota fiscal</label>
                          <input v-model="datafinancialInfo.financialInfo.number" type="text" name="number" id="number"
                                 class="form-control"/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label>Complemento para nota fiscal</label>
                          <input v-model="datafinancialInfo.financialInfo.complement" type="text" name="complement"
                                 id="complement" class="form-control"/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label>Bairro para nota fiscal</label>
                          <input v-model="datafinancialInfo.financialInfo.neighborhood" type="text" name="neighborhood"
                                 id="neighborhood" class="form-control"/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label>Cidade para nota fiscal</label>
                          <input v-model="datafinancialInfo.financialInfo.city" type="text" name="city" id="city"
                                 class="form-control"/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label>Estado para nota fiscal</label>
                          <input maxlength="2" v-model="datafinancialInfo.financialInfo.state" type="text" name="state"
                                 id="state" class="form-control"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <div class="col-md-12">
                  <div class="button-c">
                    <button v-on:click=" changeEdit(false)" class="ax-wid">
                      <span v-if="!loadingChange">Salvar</span>
                      <div class="loading-btn" v-else>
                        <div class="spinner-btn">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                          <div class="rect4"></div>
                          <div class="rect5"></div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="offset-top-20 col-xs-12 col-sm-3 col-md-3">
                    <div>
                      <strong>Plano escolhido:</strong>
                      <span>{{ dataSubscription.companyPlanStr }} -
                      {{ dataSubscription.planTypeStr }}</span>
                    </div>
                    <div>
                      <strong>Funcionários:</strong>
                      <span> {{ dataPaymentCompany.totalEmployee }} </span>
                    </div>
                  </div>
                  <div class="offset-top-20 col-xs-12 col-sm-3 col-md-3">
                    <div>
                      <strong>Data de criação:</strong>
                      <span>{{ dataPaymentCompany.company.createdAt | formatDate }}
                    </span>
                    </div>
                    <div>
                      <strong>Data do último acesso admin:</strong>
                      <span>{{ dataPaymentCompany.lastLoginAdmin | formatDate }}
                    </span>
                    </div>
                  </div>
                  <div class="offset-top-20 col-xs-12 col-sm-3 col-md-3">
                    <div>
                      <strong>Data de vencimento:</strong>
                      <span>{{ dataSubscription.recurringDayStr }}</span>
                    </div>
                    <div>
                      <strong>Valor:</strong>
                      <span>R$ {{ dataSubscription.totalCost }} </span>
                    </div>
                  </div>
                  <div class="offset-top-20 col-xs-12 col-sm-3 col-md-3">
                    <div>
                      <strong>Último pagamento:</strong>
                      <span>
                      {{ dataSubscription.lastBankSlipPaidDateStr }}
                    </span>
                    </div>
                    <div>
                      <strong>Observações:</strong>
                      <span>{{ dataPaymentCompany.company.notes }} </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";

import {
  CHANGE_FINANCIAL,
  CHANGE_DADE_FINANCIAL,
  CHANGE_COMPANY_INFO_CODE,
  COMPANY_CHANCE_DADE_INFO,
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "chance-date",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
  },
  data() {
    return {
      showNotes: false,
      loadingFinancial: false,
      loadingNotes: false,
      loadingList: false,
      loadinDadeList: false,
      loadingChange: false,
      datafinancialInfo: {
        financialInfo: {
          cnpj: "",
          representationName: "",
          zipCode: "",
          street: "",
          number: "",
          complement: "",
          neighborhood: "",
          city: "",
          state: "",
        },
      },
      dataPaymentCompany: {
        id: "",
        totalEmployee: "",
        lastLoginAdmin: "",
        representationName: "",
        phone: "",
        financialEmail: "",
        company: {
          notes: "",
          createdAt: "",
          contactName: "",
          email: "",
          name: "",
          financialEmail: "",
          companyPlanStr: "",
          address: {
            street: "",
            zipCode: "",
            number: "",
            neighborhood: "",
            city: "",
            state: "",
          },
          phone: {
            phoneNumber: "",
          },
          bussinessInfo: {
            representationName: "",
            cnpj: "",
          },
        },
      },
      dataSubscription: {
        planTypeStr: "",
        companyPlanStr: "",
        totalCost: "",
        recurringDayStr: "",
        lastBankSlipPaidDateStr: "",
      },
    };
  },
  methods: {
    getPaymentInfo() {
      this.loadingList = true;
      this.loading = false;
      let url =
        COMPANY_CHANCE_DADE_INFO + "?t=kkkk&i=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.$route.params.context)
        .then((response) => {
          UTIL_SERVICE.console(
            "RESULT COMPANY_CHANCE_DADE_INFO:",
            response.data
          );

          this.dataSubscription = response.data.subscription;
          this.dataPaymentCompany = response.data;

          this.loadingList = false;
        })
        .catch((reason) => {
          this.loadingList = false;
          this.loading = false;
        });
    },
    getDadeFinancial() {
      this.loadinDadeList = true;
      this.loading = false;
      let url = CHANGE_DADE_FINANCIAL + "?i=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.$route.params.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_DADE_FINANCIAL:", response.data);

          this.datafinancialInfo = response.data;
          this.loadinDadeList = false;
          this.showNotes = false;

          if (this.datafinancialInfo.financialInfo.cnpj || this.datafinancialInfo.financialInfo.representationName || this.datafinancialInfo.financialInfo.zipCode || this.datafinancialInfo.financialInfo.street) {
            this.showNotes = true;

          }
        })
        .catch((reason) => {
          this.loadinDadeList = false;
          this.loading = false;
        });
    },
    changeEdit() {
      this.loadingChange = true;
      if (this.dataPaymentCompany.company.address.number) {
        this.dataPaymentCompany.company.address.number = this.dataPaymentCompany.company.address.number.replace(/[^a-zA-Z0-9 ]/g, "");
      }
      UTIL_SERVICE.console("DATA SEND:", this.dataPaymentCompany);
      REQUEST_SERVICE.requestContext(
        "PUT",
        CHANGE_COMPANY_INFO_CODE,
        this.$route.params.context,
        this.dataPaymentCompany.company
      )
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_COMPANY_INFO_CODE:", response);

          this.loadingChange = false;

          swal("Aviso", "Empresa atualizada com sucesso.", "success");

          this.changeFinancial()

        })
        .catch((reason) => {
          this.loadingChange = false;
          reason.response.data.erros.map((value) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeFinancial() {
      this.loadingChange = true;
      UTIL_SERVICE.console("DATA SEND:", this.datafinancialInfo.financialInfo);
      REQUEST_SERVICE.requestContext(
        "PUT",
        CHANGE_FINANCIAL + "?id=" + this.$route.params.idCompany,
        this.$route.params.context,
        this.datafinancialInfo.financialInfo
      )

        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_FINANCIAL:", response);
          this.loadingChange = false;

          // Redirect user.
          this.$router.push({
            path: "/detalhes-da-empresa/" +
              this.$route.params.idCompany +
              "/" +
              this.$route.params.context,
          });

        })
        .catch((reason) => {
          this.loadingChange = false;
          reason.response.data.erros.map((value) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
  },
  beforeMount() {
    this.getPaymentInfo();
    this.getDadeFinancial();
  },
};
</script>

<style lang="scss">
.search-employers {
  position: absolute;
  right: 0;
  margin-top: 10px;

  .user-disabled {
    position: absolute;
    top: -55px;
    cursor: pointer;
    color: #837d7d;
    border-bottom: 1px solid #bdb3b3;

    &:hover {
      text-decoration: none;
    }
  }

  label {
    display: block;
    font-weight: 600;
    letter-spacing: 100px;
  }

  input {
    display: inline-block;
    -webkit-border-radius: 4px !important;
    -moz-border-radius: 4px !important;
    border-radius: 4px !important;
    width: 50%;
  }

  button {
    background: #3598dc;
    color: #ffffff;
    text-decoration: none;
    margin-right: 30px;
    border-radius: 4px !important;
    border: none;
    font-weight: 600;
    display: inline-block;
    height: 33px;
    line-height: 34px;
    margin-left: 0;
    padding: 0 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/companyDetail/chanceDate.vue